<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
        "
      >
        <li style="font-size: 13px; flex: 1">
          <text
            style="font-weight: 600; font-size: 14px"
            class="text-hover-decoration"
            @click="$onCopy(state.model.name)"
          >
            {{ state.model.name }}
          </text>
          -
          <text
            style="color: #1e90ff; font-weight: 600"
            class="text-hover-decoration"
            @click="$onCopy(state.model.phone)"
          >
            {{ state.model.phone }}
          </text>
          -
          <text
            style="color: #ffa500; font-weight: 600"
            class="text-hover-decoration"
            @click="$onCopy(state.model.idcard)"
          >
            {{ state.model.idcard }}
          </text>
          -
          <text
            :style="{ color: state.model.status == 0 ? '#f00' : '#1e90ff' }"
          >
            {{ state.model.status == 0 ? "停用" : "正常" }}
          </text>
        </li>
        <li>
          <el-button type="primary" link icon="Grid" @click="onBuildQrCode"
            >员工二维码</el-button
          >
          <el-button
            type="primary"
            link
            icon="Edit"
            @click="state.showEdit = true"
            >编辑信息</el-button
          >
        </li>
      </ul>
      <ul
        style="padding: 20px; overflow: hidden; transition: all linear 0.2s"
        :style="{ height: state.descHeight }"
      >
        <el-descriptions
          :column="3"
          border
          size="large"
          class="desc-box"
          ref="descDom"
        >
          <el-descriptions-item label="性别" label-align="right">
            <template #label>
              <div style="display: flex; align-items: center; width: 100%">
                <li
                  style="flex: 1; display: flex; align-items: center"
                  @click="onDescDomToggle"
                >
                  <el-icon
                    v-if="state.showMore"
                    size="22"
                    color="#1e90ff"
                    style="cursor: pointer"
                    @click="state.showMore = false"
                    title="隐藏更多信息"
                  >
                    <Hide />
                  </el-icon>
                  <el-icon
                    v-else
                    size="22"
                    color="#1e90ff"
                    style="cursor: pointer"
                    title="查看更多信息"
                    @click="state.showMore = true"
                  >
                    <View />
                  </el-icon>
                </li>
                性别
              </div>
            </template>
            <div>
              {{ state.model?.sex }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="民族" label-align="right">
            <div>
              {{ state.model?.nation || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="婚姻状况" label-align="right">
            <div>
              {{ state.model?.marital_status || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="证件类型" label-align="right">
            <div>
              {{ state.model?.idtype || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="证件生效日" label-align="right">
            <div>
              {{ state.model?.id_start || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="证件到期日" label-align="right">
            <div>
              {{ state.model?.id_end || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="生育状况" label-align="right">
            <div>
              {{ state.model?.fertility_status || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="政治面貌" label-align="right">
            <div>
              {{ state.model?.political_status || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="籍贯" label-align="right">
            <div>
              {{ state.model?.household_type || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="户籍城市" label-align="right">
            <div>
              {{ state.model?.household_city || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="户籍详细地址" label-align="right">
            <div>
              {{ state.model?.household_address || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="户口性质" label-align="right">
            <div>
              {{ state.model?.native_place || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="参加工作日期" label-align="right">
            <div>
              {{ state.model?.work_date || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="学历" label-align="right">
            <div>
              {{ state.model?.education || "-" }}
            </div>
          </el-descriptions-item>
          <template v-if="state.model.idtype != '居民身份证'">
            <el-descriptions-item label="其他证件类型" label-align="right">
              <div>
                {{ state.model?.employee?.qtzjlx || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="其他证件号码" label-align="right">
              <div>
                {{ state.model?.employee?.qtzjhm || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="国籍" label-align="right">
              <div>
                {{ state.model?.employee?.gj || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="人员地区" label-align="right">
              <div>
                {{ state.model?.employee?.rydq || "-" }}
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="出生国家" label-align="right">
              <div>
                {{ state.model?.employee?.csd || "-" }}
              </div>
            </el-descriptions-item>
             <el-descriptions-item label="首次入境时间" label-align="right">
              <div>
                {{ state.model?.employee?.scrjsj || "-" }}
              </div>
            </el-descriptions-item>
             <el-descriptions-item label="预计离境时间" label-align="right">
              <div>
                {{ state.model?.employee?.yjljsj || "-" }}
              </div>
            </el-descriptions-item>
          </template>
        </el-descriptions>
      </ul>
      <ul
        style="
          margin-top: 10px;
          flex: 1;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        "
      >
        <el-tabs
          v-model="state.activeName"
          class="detail-tabs"
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;
          "
          @tab-click="handleClick"
        >
          <el-tab-pane label="申报单位" name="sbdw">
            <c_UnitList
              :employee_id="props.data?.id"
              v-if="state.activeName == 'sbdw'"
            ></c_UnitList>
          </el-tab-pane>
          <el-tab-pane label="发薪记录" name="fxjl">
            <c_SalaryRecordList
              :employee_id="props.data?.id"
              v-if="state.activeName == 'fxjl'"
            ></c_SalaryRecordList>
          </el-tab-pane>
          <el-tab-pane label="算税记录" name="ssjl">
            <c_CalcTaxList
              :employee_id="props.data?.id"
              v-if="state.activeName == 'ssjl'"
            ></c_CalcTaxList>
          </el-tab-pane>
          <el-tab-pane label="专项附加扣除" name="zxkc">
            <c_EssentialList
              :employee_id="props.data?.id"
              v-if="state.activeName == 'zxkc'"
            ></c_EssentialList>
          </el-tab-pane>
          <el-tab-pane label="档案附件" name="file">
            <c_File
              :employee_id="props.data?.id"
              v-if="state.activeName == 'file'"
            ></c_File
          ></el-tab-pane>
        </el-tabs>
      </ul>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="编辑员工"
      @close="state.showEdit = false"
    >
      <c_EmployeeEdit
        @close="
          state.showEdit = false;
          onLoad();
        "
        :id="props.data?.id"
      ></c_EmployeeEdit>
    </c_popup>
  </transition>
  <div
    v-show="state.showQrCode"
    style="
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      z-index: 9999;
    "
    @click="state.showQrCode = false"
  >
    <div
      ref="qrcodeBox"
      style="background-color: #fff; padding: 20px"
      @click.stop=""
    >
      <div ref="qrcodeDom"></div>
      <ul
        style="
          text-align: center;
          margin-top: 5px;
          font-size: 15px;
          font-weight: 600;
        "
      >
        {{
          state.model?.name
        }}
      </ul>
      <ul style="text-align: center; color: #a2a2a2; margin-top: 5px">
        (请使用手机扫一扫填写个人档案信息)
      </ul>
    </div>
    <ul
      style="
        width: 340px;
        text-decoration: solid;
        text-align: center;
        background-color: #fff;
        padding-bottom: 10px;
      "
    >
      <a href="#" @click="onDownLoadQrCode">下载</a>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { employee_info } from "@/http/employee";

import c_UnitList from "./Detail/ApplicationUnit/List.vue";
import c_SalaryRecordList from "./Detail/SalaryRecord/List.vue";
import c_CalcTaxList from "./Detail/CalcTax/List.vue";
import c_EssentialList from "./Detail/Essential/List.vue";
import c_File from "./Detail/File.vue";

import QRCode from "qrcodejs2-fix";
import html2canvas from "html2canvas";

export default {
  components: {
    c_UnitList,
    c_SalaryRecordList,
    c_CalcTaxList,
    c_EssentialList,
    c_File,
  },
  props: {
    data: Object,
  },
  setup(props) {
    const qrcodeBox = ref(null);
    const qrcodeDom = ref(null);
    const descDom = ref(null);
    const state = reactive({
      model: {},
      activeName: "sbdw",
      descHeight: "70px",
    });
    onMounted(() => {
      employee_info(props.data?.id).then((res) => {
        if (res.status == 200) {
          state.model = res.data.data;
        }
      });
    });

    const onDescDomToggle = () => {
      if (state.descHeight == "70px")
        state.descHeight = descDom.value?.$el?.offsetHeight + 20 + "px";
      else state.descHeight = "70px";
    };

    const onBuildQrCode = () => {
      qrcodeDom.value.innerHTML = "";
      state.showQrCode = true;
      new QRCode(qrcodeDom.value, {
        text: "https://h5.ycmtc.com/login?phone=" + state.model?.phone,
        width: 300, // 二维码图片宽度
        height: 300, // 二维码图片高度
      });
    };

    const onDownLoadQrCode = () => {
      const element = qrcodeBox.value;

      html2canvas(element).then((canvas) => {
        // 创建一个图像元素
        let img = new Image();
        img.src = canvas.toDataURL("image/png");
        img.style.width = "500px"; // 可以设置图片的宽度
        img.style.height = "auto"; // 图片高度将按比例调整

        // 将图片添加到页面上显示
        // 例如，可以将img元素插入到DOM中的某个位置
        document.body.appendChild(img);

        // 如果需要下载图片
        let a = document.createElement("a");
        a.href = img.src;
        a.download = state.name + ".png";
        a.click();
      });
    };

    return {
      state,
      props,
      descDom,
      onDescDomToggle,
      qrcodeDom,
      qrcodeBox,
      onBuildQrCode,
      onDownLoadQrCode,
    };
  },
};
</script>
<style scoped></style>
